import api from './api';
import { JobPosting, Candidate, Interview } from '@/types';

// Description: Get job postings
// Endpoint: GET /api/jobs
// Request: { status?: string }
// Response: { success: boolean, jobs: JobPosting[] }
export const getJobPostings = async (params?: { status?: string }) => {
  try {
    const response = await api.get('/api/jobs', { params });
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || 'THIS SECTION IS IN PROGRESS');
  }
};

// Description: Get job posting by ID
// Endpoint: GET /api/jobs/:id
// Request: { id: string }
// Response: { success: boolean, job: JobPosting }
export const getJobPostingById = async (id: string) => {
  try {
    const response = await api.get(`/api/jobs/${id}`);
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Create job posting
// Endpoint: POST /api/jobs
// Request: { job: Partial<JobPosting> }
// Response: { success: boolean, message: string, job: JobPosting }
export const createJobPosting = async (job: Partial<JobPosting>) => {
  try {
    const response = await api.post('/api/jobs', { job });
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Apply for a job
// Endpoint: POST /api/jobs/:id/applications
// Request: { name: string, email: string, phone: string, coverLetter?: string, experience?: string, skills?: string[], resumeUrl?: string }
// Response: { success: boolean, message: string, candidate: Candidate }
export const applyForJob = async (jobId: string, applicationData: {
  name: string;
  email: string;
  phone: string;
  coverLetter?: string;
  experience?: string;
  skills?: string[];
  resumeUrl?: string;
}) => {
  try {
    const response = await api.post(`/api/jobs/${jobId}/applications`, applicationData);
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Get candidates
// Endpoint: GET /api/candidates
// Request: { jobId?: string, stage?: string }
// Response: { success: boolean, candidates: Candidate[] }
export const getCandidates = async (params?: { jobId?: string; stage?: string }) => {
  try {
    const response = await api.get('/api/candidates', { params });
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Update candidate stage
// Endpoint: PUT /api/candidates/:id/stage
// Request: { id: string, stage: string, notes?: string }
// Response: { success: boolean, message: string, candidate: Candidate }
export const updateCandidateStage = async (id: string, stage: string, notes?: string) => {
  try {
    const response = await api.put(`/api/candidates/${id}/stage`, { stage, notes });
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Schedule interview
// Endpoint: POST /api/interviews
// Request: { interview: Partial<Interview> }
// Response: { success: boolean, message: string, interview: Interview }
export const scheduleInterview = async (interview: Partial<Interview>) => {
  try {
    const response = await api.post('/api/interviews', { interview });
    return response.data;
  } catch (error: any) {
    console.error(error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};